import { useQuery } from '@tanstack/react-query';
import { EmailProblemsApi, IEmailProblemStatus } from '../apis/EmailProblemsApi/EmailProblemsApi';
import { useSessionProvider } from '../provider/sessionContext';

export const useEmailWarning = () => {
    const { currentUser } = useSessionProvider();

    const {
        data: emailStatus,
        isLoading,
        error,
    } = useQuery<IEmailProblemStatus>({
        queryKey: ['emailWarning', currentUser?.patientID, currentUser?.healthcareProfessionalID],
        queryFn: () => EmailProblemsApi.getCurrentUserEmailStatus(),
        enabled: !!currentUser, // Only run if user is logged in
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: false, // Don't retry on error to avoid spam
    });

    return {
        hasEmailProblem: emailStatus?.hasEmailProblem || false,
        emailProblemType: emailStatus?.emailProblemType,
        email: emailStatus?.email || '',
        shouldShowWarning: emailStatus?.shouldShowWarning || false,
        isLoading,
        error,
    };
}; 